import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import "../BalanceSheet/Reports.scss";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "../../Components";
import { convertToISO } from "../../../CommonFunction/IsoDateTime";
import ReportsMenu from "../BalanceSheet/ReportsMenu";

const AllReportsData = gql`
  query getAccountDataForTrandingReport($startDate: ISODate, $endDate: ISODate) {
    getAccountDataForTrandingReport(startDate: $startDate, endDate: $endDate)
  }
`;

const TradingReport = () => {
  const [formdata, setformdata] = useState<any>({});
  let Refetch = useSelector((store: any) => store.FormFieldData.refresh);
  let Date = useSelector((store: any) => store?.financialYear?.SelectedDate);
  const ToDate = Date.ToDate
  const FromDate = Date.ToDate
  const dispatch = useDispatch();
  const {
    data: Reports,
    refetch,
    loading,
  } = useQuery(AllReportsData, {
    variables: {
      startDate: FromDate,
      endDate: ToDate,
    },
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (Refetch) {
      refetch({
        variables: {
          startDate: FromDate,
          endDate: ToDate,
        },
      });
      dispatch({ type: "Refetch", payload: false });
    }
  }, [Refetch]);
  useEffect(() => {

    if (Reports) {
      setformdata(Reports?.getAccountDataForTrandingReport?.Result);
    }
  }, [Reports]);
  useEffect(() => {
    refetch({
      variables: {
        startDate: FromDate,
        endDate: ToDate,
      },
    });
  }, [FromDate, ToDate, refetch]);

  return (
    <div className="reportsdatacontainer">
      {/* <div className="HeaderDiv">
        <div>
          <p className="pageTitle">Balance Sheet</p>
          <div className="hr1ForPageTitle"></div>
        </div>
      </div> */}

      <HeaderDiv title={"Trading Report"} />
      {loading ? (
        <Loading />
      ) : (
        <div className="reportsdata">
          <div className="Reporsdatasub">
            <h3>Debit</h3>
            <hr />
            <ReportsMenu
              data={formdata?.Debit?.accountGroupsData}
              type="Debit"
              Profit={{ Gross_Profit: formdata?.Debit?.DisplayGross_Profit }}
            />
            <div className="TotalContainer">Debit Total:{formdata?.Debit?.DisplayTotalClosing}</div>
          </div>
          <div className="Reporsdatasub">
            <h3>Credit</h3>
            <hr />
            <ReportsMenu
              data={formdata?.Credit?.accountGroupsData}
              type={"Credit"}
              Profit={{ Gross_Loss: -1 * formdata?.Credit?.DisplayGross_Loss }}
            />
            <div className="TotalContainer">Credit Total:{formdata?.Credit?.DisplayTotalClosing}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TradingReport;
